import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomCrearUbicaciones extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal                                  = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged']           = this.onSelectionChangedPrincipal;

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);

        this.sucessActualizar = this.sucessActualizar.bind(this);
        this.grabarUbicaciones = this.grabarUbicaciones.bind(this);

        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.servicio = '';
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
        this.array_columnas=[];
        this.tamano_formato=4;
    }

    initForm() {
        console.log('Formulario CustomCrearUbicaciones,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        this.getField('columnas').setOnChange((props) => {
            this.limpiarCampos();
        });

        this.getField('estante').setOnChange((props) => {
            this.limpiarCampos();
        });


        this.getField('bt_crear').setClick((props) => {
            this.crearColumnas();
        });

       
 
        this.getField('bt_grabar').setClick(()=>{
            this.grabarUbicaciones();
        });


        this.getField('bt_crear_estibas').setClick(() => {
            this.crearE = true;
            this.limp = false;
            this.getField('cantidad_estibas').setVisible(true);
            this.getField('modal_estibas').handleClickOpen();
        });

        this.getField('bt_limpiar').setClick(() => {
            this.crearE = false;
            this.limp = true;
            this.getField('cantidad_estibas').setVisible(false);
            this.getField('modal_estibas').handleClickOpen();
        });

        this.getField('bt_aceptar').setClick(() => {
            if (this.getField('select_columnas').valid()) {
                if (this.crearE) {
                    if (this.getField('cantidad_estibas').valid()) {
                        this.array_columnas.forEach((element) => {
                            if (element.columna === Number(this.getField('select_columnas').getValue())) {
                                element.estibas = this.getField('cantidad_estibas').getValue();

                            }
                        });
                        this.getField('modal_estibas').handleClose();
                        this.dibujarEstibas();
                    }
                } else if (this.limp) {
                    this.array_columnas.forEach((element) => {
                        if (element.columna === Number(this.getField('select_columnas').getValue())) {
                            element.estibas = 0;
                        }
                    });
                    this.getField('modal_estibas').handleClose();
                    this.dibujarEstibas();
                }
            }
        });

        this.getField('bt_cancelar').setClick(() => {
            this.getField('modal_estibas').handleClose();
        });

    }

    crearColumnas(){
        if(this.getField('estante').valid() && this.getField('columnas').valid()){
            this.array_columnas=[];

                for (let i = 1; i <= Number(this.getField('columnas').getValue()); i++) {
                    let objeto={
                        columna:i,
                        estibas:0
                    }
                    this.array_columnas.push(objeto)
                }
                this.array_columnas.sort();
                this.dibujarEstibas();

                //llenar select

                let opciones = [{ 'text': 'Ninguno', 'value': ' ', 'campos_cambian': {} }];

                this.array_columnas.forEach(item => {
                    let dataOp = {}
                    dataOp['value'] = item.columna;
                    dataOp['text'] = item.columna;
                    dataOp['campos_cambian'] = {/* separador_select: item.valor */ };
                    opciones.push(dataOp);
                });
                this.getField('select_columnas').setOptions(opciones);
        }
    }

    dibujarEstibas(){
        this.getField("rejilla").toggle(false);
        let codigo_estante=this.getField('estante').getValue();
        this.array_datos=[]
        this.array_columnas.forEach(element => {
            if(element.estibas !==undefined && element.estibas<=0){
                let objeto={
                    columna:element.columna,
                    ubicacion:'0'
                }
                this.array_datos.push(objeto)
            }else{
                for (let estiba = 0; estiba < element.estibas; estiba++) {
                    let ubicacion = "0".repeat(this.tamano_formato-codigo_estante.toString().length)+ codigo_estante + "0".repeat(this.tamano_formato-element.columna.toString().length)+element.columna +"0".repeat(this.tamano_formato-(estiba + 1).toString().length) +(estiba + 1);
                    let objeto={
                        columna:element.columna,
                        ubicacion:ubicacion
                    }
                    this.array_datos.push(objeto)
                }
            }
        });
        
        this.array_datos.sort();
        this.getField("rejilla").toggle(true);
        this.gridOptionsComponentes["rowData"] = this.array_datos;
        let configCell = new Map();
        configCell.set('columna', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.columna) }, cellStyle: {textAlign:"right"}});
        this.getField('rejilla').initData(this.gridOptionsComponentes,configCell);
        this.getField('bt_crear_estibas').setVisible(true);
        this.getField('bt_limpiar').setVisible(true);
    }

    onSelectionChangedPrincipal(){

    }


    grabarUbicaciones(){
        if(this.getField('estante').valid() && 
        this.getField('columnas').valid() &&
        this.getField('select_ubicaciones').valid()){

            //validar si hay estibas en 0
            let columnas='';
            this.array_columnas.forEach(element => {
                if(element.estibas !==undefined && element.estibas<=0){
                    columnas+=element.columna+',';
                }
            });
            if(columnas.length<=0 && this.array_columnas.length>0){
                this.mostrarMensajeGenerando();
                let datos={ datos: {
                    sucursal_ingreso:this.sucursal_ingreso,
                    estante :this.getField('estante').getValue(),
                    columnas :this.getField('columnas').getValue(),
                    select_ubicaciones :this.getField('select_ubicaciones').getValue(),
                    array_columnas :this.array_columnas,
                }};
                this.generalFormatPmv = { tipo_servicio: 'inve-crearubicaciones', operacion: 'grabar', operacion_tipo: 'crear' };
                this.service.send(
                {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.sucessActualizar,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                });
            }else{
                if(this.array_columnas.length>0)
                    this.mostrarMensajeAdicional('Por favor, cree estibas en todas las columnas. Columnas faltantes: '+columnas.substring(0,columnas.length-1));
                else
                    this.mostrarMensajeAdicional('Por favor, cree estibas en todas las columnas.');

            }
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    sucessActualizar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            if(data.data.input!==undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                        this.mostrarMensajeGuardando();

                        let datos={ datos: {
                            sucursal_ingreso:this.sucursal_ingreso,
                            estante :this.getField('estante').getValue(),
                            columnas :this.getField('columnas').getValue(),
                            select_ubicaciones :this.getField('select_ubicaciones').getValue(),
                            array_columnas :this.array_columnas,
                            input:'1',
                        }};
                        this.generalFormatPmv = { tipo_servicio: 'inve-crearubicaciones', operacion: 'grabar', operacion_tipo: 'crear' };
                        this.service.send(
                        {
                                endpoint: this.constant.formConfiguration(),
                                method:'POST',
                                body: datos,
                                success: this.sucessActualizar,
                                error: this.error_,
                                general: this.generalFormatPmv,
                                showMessage: false
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.mostrarMensajeAdicional('Grabado con éxito.');
                this.getField('select_ubicaciones').setValue('');
                this.getField('estante').setValue('');
                this.getField('columnas').setValue('');
                this.limpiarCampos();
            }
        }else {
          if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
          }
          else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
          }
        }
      }



    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-crearubicaciones', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            this.wms_nuevo = data.data.wms_nuevo;

            if(this.wms_nuevo!=='N'){
                this.getField('estante').setVisible(false);
                this.getField('columnas').setVisible(false);
                this.getField('bt_crear').setVisible(false);
                this.getField('select_ubicaciones').setVisible(false);
                this.getField('bt_grabar').setVisible(false);
                this.mostrarMensajeAdicional('OPCIÓN NO AUTORIZADA! (I0069)');
            }
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {
        this.getField('estante').setError(false,'');
        this.getField('columnas').setError(false,'');
        this.getField('rejilla').toggle(false);
    

        this.getField('bt_crear_estibas').setVisible(false);
        this.getField('bt_limpiar').setVisible(false);
        this.array_columnas=[];
    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("inve-crearubicaciones", CustomCrearUbicaciones);
export default CustomCrearUbicaciones